import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import ContextMenu, { Position } from 'devextreme-react/context-menu';
import List from 'devextreme-react/list';
import { useAuth } from '../../contexts/auth';
import './user-panel.scss';
import userImg from './login-user.png';
import { AuthStore } from '../../common/store';

// eslint-disable-next-line import/no-anonymous-default-export
export default function ({ menuMode }) {
  const { user } = AuthStore;
  const history = useHistory();

  const menuItems = useMemo(
    () => [
      {
        text: '비밀번호변경',
        icon: 'user',
        onClick: () => history.push('/reset-password'),
      },
      {
        text: '로그아웃',
        icon: 'runner',
        onClick: () => AuthStore.logout(),
      },
    ],
    [history]
  );

  return (
    <div className={'user-panel'}>
      <div className={'user-info'}>
        <div className={'image-container'}>
          <div
            style={{
              background: `url(${userImg}) no-repeat #fff`,
              backgroundSize: 'cover',
            }}
            className={'user-image'}
          />
        </div>
        <div className={'user-name'}>{user.Name}</div>
      </div>

      {menuMode === 'context' && (
        <ContextMenu
          items={menuItems}
          target={'.user-button'}
          showEvent={'dxclick'}
          width={210}
          cssClass={'user-menu'}
        >
          <Position my={'top center'} at={'bottom center'} />
        </ContextMenu>
      )}
      {menuMode === 'list' && (
        <List className={'dx-toolbar-menu-action'} items={menuItems} />
      )}
    </div>
  );
}
